export const PERSONALIZED_HOLIDAY_FULL_BLEED = {
  'dfd39027-d134-4353-b9e4-57dc6be791b9': 'holiday23-guitar-pedal-amp-top-web', // electric guitars
  '3ca3eb03-7eac-477d-b253-15ce603d2550': 'holiday23-guitar-pedal-amp-top-web', // acoustic guitars
  'fa10f97c-dd98-4a8f-933b-8cb55eb653dd': 'holiday23-guitar-pedal-amp-top-web', // effects and pedals
  '09055aa7-ed49-459d-9452-aa959f288dc2': 'holiday23-guitar-pedal-amp-top-web', // amps
  'd002db05-ab63-4c79-999c-d49bbe8d7739': 'holiday23-keys-top-web', // keys and synths
  'b021203f-1ed8-476c-a8fc-32d4e3b0ef9e': 'holiday23-audio-top-web', // home recording (pro-audio)
};
export const PERSONALIZED_HOLIDAY_FULL_BLEED_FALLBACK = 'holiday23-fallback-top-web';

export const PERSONALIZED_HOLIDAY_MID = {
  'dfd39027-d134-4353-b9e4-57dc6be791b9': 'holiday23-guitar-pedal-amp-mid-web', // electric guitars
  '3ca3eb03-7eac-477d-b253-15ce603d2550': 'holiday23-guitar-pedal-amp-mid-web', // acoustic guitars
  'fa10f97c-dd98-4a8f-933b-8cb55eb653dd': 'holiday23-guitar-pedal-amp-mid-web', // effects and pedals
  '09055aa7-ed49-459d-9452-aa959f288dc2': 'holiday23-guitar-pedal-amp-mid-web', // amps
  'd002db05-ab63-4c79-999c-d49bbe8d7739': 'holiday23-keys-mid-web', // keys and synths
  'b021203f-1ed8-476c-a8fc-32d4e3b0ef9e': 'holiday23-audio-mid-web', // home recording (pro-audio)
};

export const PERSONALIZED_HOLIDAY_MID_FALLBACK = 'holiday23-fallback-mid-web';

export const PERSONALIZED_HOLIDAY_LOW = {
  'dfd39027-d134-4353-b9e4-57dc6be791b9': 'holiday23-guitar-pedal-amp-low-web', // electric guitars
  '3ca3eb03-7eac-477d-b253-15ce603d2550': 'holiday23-guitar-pedal-amp-low-web', // acoustic guitars
  'fa10f97c-dd98-4a8f-933b-8cb55eb653dd': 'holiday23-guitar-pedal-amp-low-web', // effects and pedals
  '09055aa7-ed49-459d-9452-aa959f288dc2': 'holiday23-guitar-pedal-amp-low-web', // amps
  'd002db05-ab63-4c79-999c-d49bbe8d7739': 'holiday23-keys-low-web', // keys and synths
  'b021203f-1ed8-476c-a8fc-32d4e3b0ef9e': 'holiday23-audio-low-web', // home recording (pro-audio)
};
export const PERSONALIZED_HOLIDAY_LOW_FALLBACK = 'holiday23-fallback-low-web';
